// extracted by mini-css-extract-plugin
module.exports = {"scriptContent":"ScriptSection_scriptContent__xmg-q","embed":"ScriptSection_embed__1At5j"};